import { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgToggleOn = (props: PropsType) => {
  return (
    <svg
      width='29'
      height='14'
      viewBox='0 0 29 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style ? props.style : undefined}
    >
      <g mask='url(#mask0_1235_3833)'>
        <path
          d='M7.02577 14C5.07425 14 3.41535 13.3204 2.04906 11.9611C0.68302 10.6015 0 8.95082 0 7.00894C0 5.06681 0.68302 3.41312 2.04906 2.04787C3.41535 0.682624 5.07425 0 7.02577 0H21.9742C23.9257 0 25.5847 0.679646 26.9509 2.03894C28.317 3.39848 29 5.04918 29 6.99106C29 8.93319 28.317 10.5869 26.9509 11.9521C25.5847 13.3174 23.9257 14 21.9742 14H7.02577Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
        <path
          d='M21.9697 10.5C22.9444 10.5 23.7743 10.1602 24.4594 9.48053C25.1445 8.80089 25.4871 7.97553 25.4871 7.00447C25.4871 6.0334 25.146 5.20656 24.4639 4.52394C23.7817 3.84131 22.9534 3.5 21.9787 3.5C21.0041 3.5 20.1742 3.83982 19.489 4.51947C18.8039 5.19911 18.4613 6.02447 18.4613 6.99553C18.4613 7.9666 18.8024 8.79344 19.4846 9.47606C20.1667 10.1587 20.9951 10.5 21.9697 10.5Z'
          fill='white'
        />
      </g>
    </svg>
  );
};

export default SvgToggleOn;
